import { ReactNode, useCallback, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { Tooltip } from '../tooltip';

const StyledTruncated = styled.span`
	display: block;
	min-width: 0;
	max-width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export function TableTruncatedContent({ tooltip, children }: { tooltip?: ReactNode; children: ReactNode }): JSX.Element {
	const elementRef = useRef<HTMLSpanElement | null>(null);
	const [isTruncated, setIsTruncated] = useState(false);

	const updateIsTruncated = useCallback(() => {
		const element = elementRef.current;
		if (element) {
			setIsTruncated(element.scrollWidth > element.clientWidth);
		}
	}, []);

	useEffect(() => {
		const element = elementRef.current;
		if (!element) {
			return;
		}

		updateIsTruncated();
		const observer = new ResizeObserver(updateIsTruncated);
		observer.observe(element);

		return () => observer.disconnect();
	}, [updateIsTruncated]);

	return (
		<StyledTruncated ref={elementRef}>
			<Tooltip content={isTruncated ? (tooltip ?? children) : undefined}>
				<span>{children}</span>
			</Tooltip>
		</StyledTruncated>
	);
}
